// extracted by mini-css-extract-plugin
export default {"tableWrap":"BaechaListTable_tableWrap__bFqQ3","clickable":"BaechaListTable_clickable__QIHtg"};